<div class="h-full flex flex-col bg-neutral-3 rounded-2xl p-4">
  <div class="py-2 px-6 mb-2">
    <div class="flex justify-between items-center">
      <h2 class="text-4xl font-bold">{{ pageTitle() }}</h2>
      
      @if (isOperatorsRoute()) {
        <app-add-button 
          label="Add Operator" 
          (clicked)="onAddOperator()" 
        />
      }
    </div>
    
    <!-- Search bar -->
    <div class="mt-4 flex justify-start">
      <div class="relative w-full max-w-2xl">
        <span class="absolute inset-y-0 left-4 flex items-center pointer-events-none">
          <img src="/search.svg" alt="Search" class="w-5 h-5 text-gray-400" />
        </span>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange($event)"
          placeholder="Search"
          class="w-full pl-12 pr-4 py-3 bg-white rounded-full border border-gray-200 text-gray-500 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-200 transition"
          style="box-shadow: 0 1px 2px 0 rgba(0,0,0,0.03);"
        />
      </div>
    </div>
  </div>
  
  <div class="flex-1 overflow-auto">
    @if (loading()) {
      <div class="p-4 text-center text-gray-500">
        Loading users...
      </div>
    } @else if (filteredUsers().length === 0) {
      <div class="p-4 text-center text-gray-500">
        No users found.
      </div>
    } @else {
      <div class="space-y-2 mt-2">
        @for (user of filteredUsers(); track user.id) {
          <app-user-item [user]="user" class="block mb-2"></app-user-item>
        }
      </div>
    }
  </div>
</div>